import { useCallback } from 'react';
import { IRollingInfo, IRollingItem } from '@/types';
import { COMPONENT_TYPE, PLACEHOLDER_MIDDLE_BANNER } from '@/const';
import { clickEventHandler } from '@/helpers';
import { useCommonParams, useDeviceId, useLoading } from '@/hooks';
import {
  Container,
  ImageWrapper,
  Wrapper,
  Image,
} from '@/components/organisms/insuranceMiddleBanner/InsuranceMiddleBanner.styled';
import { IntersectionObserver } from '@/components/common';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay, SwiperOptions } from 'swiper';

SwiperCore.use([Autoplay]);

const InsuranceMiddleBanner = (props: IRollingInfo) => {
  const { ads } = props;
  const [deviceId] = useDeviceId();

  const commonParams = useCommonParams();
  const [, setLoading] = useLoading();
  const removeAppBanner = ads?.filter((item) => item.destinationType !== 'A');

  const swiperSettings: SwiperOptions = {
    slidesPerView: 1.125,
    spaceBetween: 10,
    centeredSlides: true,
    autoHeight: true,
    loop: removeAppBanner ? removeAppBanner.length > 1 : false,
    autoplay:
      removeAppBanner && removeAppBanner.length > 1
        ? {
            delay: 5000,
            disableOnInteraction: false,
          }
        : false,
  };

  const handleClick = useCallback(
    async (item: IRollingInfo) => {
      await clickEventHandler({
        ...item,
        ...commonParams,
        setLoading,
        deviceId,
      });
    },
    [commonParams, setLoading, deviceId],
  );

  const renderComponent = (item: IRollingItem, index: number) => {
    return (
      <SwiperSlide key={index} onClick={() => handleClick(item)}>
        <IntersectionObserver {...item} componentName={COMPONENT_TYPE.ROLLING}>
          <ImageWrapper>
            <Image
              src={item.imgPath || PLACEHOLDER_MIDDLE_BANNER}
              alt={item.name || 'banner image'}
              loading="lazy"
            />
          </ImageWrapper>
        </IntersectionObserver>
      </SwiperSlide>
    );
  };

  return (
    <Container>
      <Wrapper>
        <Swiper {...swiperSettings}>
          {removeAppBanner?.map((item: IRollingItem, index) => renderComponent(item, index))}
        </Swiper>
      </Wrapper>
    </Container>
  );
};

export default InsuranceMiddleBanner;
